import { AutotextoModelo } from "./AutotextoModelo";
import { AutotextoNo } from "./AutotextoNo";

const CATEGORIA_INDEFINIDA = 'Não classificado'

export class AutotextoAgrupado implements AutotextoNo {
    static DESCRICAO_COM_TITULOS = 'Autotexto';
    static CAMPO_TIULO = 'titulo';
    descricao: string;
    campos: AutotextoModelo[];
    filhos: AutotextoNo[];

    constructor(descricao: string, campos: AutotextoModelo[]) {
        this.descricao = descricao;
        this.campos = campos;
    }

    public static getGruposAutotextoBy(campos:AutotextoModelo[], campo:string) : AutotextoAgrupado[] {
        return agruparPor(campos,campo);
    }
}

function agruparPor(objetos:AutotextoModelo[], atributo:string) : AutotextoAgrupado[]  {
    const categorias = objetos.reduce((acc,obj)=>{
        return obj[atributo] ? acc.add(obj[atributo]) : acc;
    }, new Set<string>())

    categorias.add(CATEGORIA_INDEFINIDA);

    const pegarObjetosDaCategoria = (categoria) => {
        if(categoria===CATEGORIA_INDEFINIDA) {
            return objetos.filter((objeto) => {
                return !objeto[atributo];
            }, atributo)
        }
        return objetos.filter((objeto) => {
            return objeto[atributo]===categoria;
        }, atributo)
    }

    return Array.from(categorias).map((categoria:string) => {
        return new AutotextoAgrupado( categoria, pegarObjetosDaCategoria(categoria)) ;
    })
}
